var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    data
  } = options;
  let properties = data.properties.notify_search_result;
  let criteria = MOVE_DATA.rs_criteria.recommended_searches[0];
  let priceString = criteria.price_max === criteria.price_min ? criteria.price_max : `$${Number(criteria.price_min).toLocaleString()} - $${Number(criteria.price_max).toLocaleString()}`;
  let bedsString = criteria.beds_max === criteria.beds_min ? criteria.beds_max : `${criteria.beds_min} - ${criteria.beds_max}`;
  let bathsString = criteria.baths_max === criteria.baths_min ? criteria.baths_max : `${criteria.baths_min} - ${criteria.baths_max}`;
  let bedsSuffix = Number(bedsString) === 1 ? 'Bed' : 'Beds';
  let bathsSuffix = Number(bathsString) === 1 ? 'Bath' : 'Baths';

__p+='\n\n';

  const createNewLabel = function(property) {
    return property.listing_age && property.listing_age.match(/hour|minute/) ? `New - ${property.listing_age.replace(/minute/, 'min')} ago` : 'New'
  };

__p+='\n\n<div class="notify-title ellipsis">\n  We recommend searching in\n</div>\n<div class="criteria-title">\n  '+
((__t=( criteria.search_title.replace("Recommended:",'').replace(/[^,]*$/, (d) => { return d.toUpperCase() }) ))==null?'':__t)+
' Area |\n  '+
((__t=( priceString ))==null?'':__t)+
' |\n  '+
((__t=( `${bedsString} ${bedsSuffix}` ))==null?'':__t)+
' |\n  '+
((__t=( `${bathsString} ${bathsSuffix}` ))==null?'':__t)+
'\n</div>\n<div id="srp-list" class="srp-list modal-body">\n  <div id="notification-list">\n    ';
 if (properties && properties.length) { 
__p+='\n    <ul class="srp-list-marginless list-unstyled prop-list">\n      ';
 properties.forEach((property, index) => { 
__p+='\n        ';
 let listing_index = index + 2500 
__p+='\n        ';
 let newLabel = createNewLabel(property); 
__p+='\n        '+
((__t=( JST["srp/basecamp/templates/optimizely/smart_notification/notification-srp-card"]({property, listing_index, newLabel }) ))==null?'':__t)+
'\n      ';
 }) 
__p+='\n    </ul>\n    ';
 }  else { 
__p+='\n      <div class="no-homes-around"> Sorry! No Notification available at this time!</div>\n    ';
 }
__p+='\n  </div>\n</div>\n<div id="notification-see-more" data-omtag="for_sale:srp_list:notifications_modal:see_more"><button id="see-more-ntf-btn" class="notification-see-more">See More</button></div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./srp/basecamp/templates/optimizely/smart_notification/notification_properties.jst.ejs